export const getLoginRoute = () => '/';
export const getPhoneRoute = () => '/phone';
export const getCdrRoute= () => '/callhistory';
export const getContactRoute= () => '/contact';
export const getMessageRoute= () => '/message';
export const getVoicemailRoute= () => '/voicemail';
export const getCallParkRoute= () => '/callpark';
export const getSettingRoute= () => '/setting';
export const getFeedbackRoute= () => '/feedback';
export const getAnalyticsRoute = () => '/analytic';
export const getCallCenterRoute= () => '/callcenter';
export const getDuplicateInstanceRoute = () => '/duplicate-instance';